export default {
  cpd: (id) => `cpd_awards/awards?memberNo=${id ? "A00000" : id}`,
  update: "profile/update",
};
